import { render } from "./InfoUser.vue?vue&type=template&id=15b6db6d&scoped=true&ts=true"
import script from "./InfoUser.vue?vue&type=script&lang=ts"
export * from "./InfoUser.vue?vue&type=script&lang=ts"

import "./InfoUser.vue?vue&type=style&index=0&id=15b6db6d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b6db6d"]])

export default __exports__